import { render } from "./CertificateVerification.vue?vue&type=template&id=1d20ec1c&scoped=true"
import script from "./CertificateVerification.vue?vue&type=script&lang=js"
export * from "./CertificateVerification.vue?vue&type=script&lang=js"

import "./CertificateVerification.vue?vue&type=style&index=0&id=1d20ec1c&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d20ec1c"]])

export default __exports__